module.exports = __webpack_public_path__ + "static/media/shutterstock_1125901340-GRADED.bd09889d.jpg";